
import { types } from "../types/types";

const defaultState = {
    map: null,
}

export const mapReducer = ( state=defaultState, action ) => {
    switch ( action.type ) {
        case types.setMap:
            return {
                ...state,
                map: action.payload
            }
        default:
            return state;
    }
}

